<template>
  <v-dialog v-model="showAll" persistent max-width="700px">
    <v-toolbar class="primary" dark>
      <v-toolbar-title>Notifications</v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn icon @click="showAll = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card class="pl-4 pr-4 pb-4">
      <v-list dense class="notif-list" two-line>
        <v-subheader v-if="unreadNotifications.length" class="subheader"
          >Unread</v-subheader
        >
        <template v-for="(item, index) in unreadNotifications">
          <v-divider inset :key="`div-${index}`" v-if="index > 0" />
          <component
            :key="`comp-${index}`"
            :is="componentName[item.type]"
            :notification="item"
            @readAndGo="goToSource(item)"
            @read="markAsRead(item)"
          />
        </template>
        <v-divider v-if="unreadNotifications.length" />

        <v-subheader v-if="readNotifications.length" class="subheader"
          >Read</v-subheader
        >
        <template v-for="(item, index) in readNotifications">
          <v-divider inset :key="`div-read-${index}`" v-if="index > 0" />
          <component
            :key="`comp-read-${index}`"
            :is="componentName[item.type]"
            :notification="item"
            @readAndGo="goToSource(item)"
          />
        </template>
        <v-divider v-if="readNotifications.length" />
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import Notification from '@/modules/auth/models/Notification'
import CompleteLesson from './type/CompleteLesson'
import StudentSubscribe from './type/StudentSubscribe'
import AccessChange from './type/AccessChange'
import NewMessageNotification from './type/NewMessageNotification'
import ChangeProfile from './type/ChangeProfile'
import { mapMutations } from 'vuex'
import { filter } from 'lodash'

export default {
  name: 'NotificationAll',
  components: {
    CompleteLesson,
    StudentSubscribe,
    AccessChange,
    NewMessageNotification,
    ChangeProfile
  },
  props: {
    type: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      showAll: false,
      componentName: {
        'App\\Notifications\\StudentCompletedClassNotification': CompleteLesson,
        'App\\Notifications\\StudentSubscribedToClass': StudentSubscribe,
        'App\\Notifications\\StudentForgotPasswordRequest': AccessChange,
        'App\\Notifications\\NotifyStudentNewMessageAddedToClass': NewMessageNotification,
        'Modules\\Student\\Notifications\\TeacherChangedStudentProfile': ChangeProfile
      }
    }
  },
  async mounted() {
    try {
      await Notification.dispatch('getAll', this.type)
    } catch (error) {
      this.showErrorSnackbar('Error retrieving notifications')
    }
  },
  computed: {
    unreadNotifications() {
      return filter(
        this.notifications,
        notification => notification.read_at === null
      )
    },
    readNotifications() {
      return filter(
        this.notifications,
        notification => notification.read_at !== null
      )
    },
    notifications() {
      return Notification.query().get()
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showErrorSnackbar']),
    async readAll() {
      await Notification.dispatch('readAll', this.type)
    },
    notificationIcon(type) {
      if (type === 'App\\Notifications\\StudentCompletedClass') {
        return 'school'
      } else {
        return 'person_add'
      }
    },
    async goToSource(notification) {
      this.showAll = false
      let sameRoute = false
      if (this.$router.currentRoute.name === 'Classes') sameRoute = true

      this.$router.push({
        path: `/teacher/dashboard/classes?currentClassId=${notification.data.custom_class_id}&currentParentTab=students&currentChildTab=0&classInvitationId=${notification.data.class_invitation_id}&studentId=${notification.data.student_id}`
      })

      await this.markAsRead(notification)
      if (sameRoute) this.$router.go()
    },
    setNotifItems(list) {
      this.notifications = list
    },
    async markAsRead(notification) {
      const payload = {
        type: this.type,
        id: notification.id
      }
      await Notification.dispatch('readSingle', { payload: payload })
    }
  }
}
</script>

<style lang="scss">
.notification {
  .badge {
    .red {
      top: 0;
      right: 0;
    }
  }

  .subheader {
    font-size: 1rem;
  }
}
</style>
